import { Component, Output, EventEmitter, Input } from '@angular/core';
import { MainTableComponent } from '../main-table.component';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { of as observableOf } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import { TableResponseQuery } from '../../../core/models/';
import {PageEvent} from '@angular/material/paginator';

@Component({
    selector: 'select-table',
    templateUrl: './select-table.component.html',
    styleUrls: ['../main-table.component.scss'],
})
export class SelectTableComponent extends MainTableComponent {
    selectionModel = new SelectionModel<any>(true, []);

    // func to get pagin size from another table
    @Input()
    set customPageSize(value: number) {
        if (value === this.pageSize) {
            return;
        }
        this.pageSize = value;
        // change pagination pageSize to emit page event
        this.paginator._changePageSize(this.pageSize);
    }
    @Input() selectedData: any[] = [];
    @Input() columnSelectData: Array<any>;

    @Output() customPageSizeChange = new EventEmitter();
    @Output() addRow = new EventEmitter();

    ngOnInit(): void {
        const columns = JSON.parse(JSON.stringify(this.columnSelectData));
        this.idFieldName = columns.shift().columnDef;
        this.displayedColumns = [
            'select',
            ...columns.map((c) => c.columnDef),
            'actions',
        ];

        this.connectToDataSource();
    }

    loadPage() {
        this.loadSubscription = this.paginator.page
            .pipe(
                startWith({}),
                switchMap(() => {
                    this.isLoadingResults = true;
                    return this.dataService.fetchSelectData(
                        this.pageSize,
                        this.paginator.pageIndex * this.pageSize,
                        this.sortBy,
                        this.filterValue,
                        this.selFilterValue
                    );
                }),
                map((data: TableResponseQuery) => {
                    this.itemsLength = data.total_count;
                    this.isLoadingResults = false;
                    return data.items;
                }),
                catchError(() => {
                    this.isLoadingResults = false;
                    return observableOf([]);
                })
            )
            .subscribe((data: any[]) => {
                this.data = data;
            });
    }

    // inner function to change pagin size and emit change to parent component
    private setCustomPageSize(value: number) {
        this.pageSize = value;
        this.customPageSizeChange.emit(this.pageSize);
    }

    // override pagination func to emit page size change event
    // to sync two tables
    // this function also emits this.paginator.page for sub
    getPaginatorData(event: PageEvent): PageEvent {
        this.setCustomPageSize(event.pageSize);
        if (event.pageIndex == this.pageIndex + 1) {
            this.lowValue = this.lowValue + this.pageSize;
            this.highValue = this.highValue + this.pageSize;
        } else if (event.pageIndex == this.pageIndex - 1) {
            this.lowValue = this.lowValue - this.pageSize;
            this.highValue = this.highValue - this.pageSize;
        }
        this.pageIndex = event.pageIndex;

        return event;
    }

    public scrollTop() {
        document.querySelector('#select-table').scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    public addAllItems(): void {
        this.isLoadingResults = true;
        this.dataService
            .fetchSelectData(
                0,
                0,
                this.sortBy,
                this.filterValue,
                this.selFilterValue
            )
            .pipe(
                map((data: TableResponseQuery) => {
                    this.itemsLength = data.total_count;
                    this.isLoadingResults = false;
                    data.items.map((item) => this.selectRow(item));
                }),
                catchError(() => {
                    this.isLoadingResults = false;
                    return observableOf([]);
                })
            )
            .subscribe();
    }

    hasBeenUsed(id: number) {
        return this.selectedData.find(
            (selected) => id === selected[this.idFieldName]
        )
            ? true
            : false;
    }

    selectRow(row) {
        this.addRow.emit(row);
        this.selectionModel.deselect(row);
    }

    isAllSelected() {
        const numSelected = this.selectionModel.selected.length;
        return numSelected > 1;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected()
            ? this.selectionModel.clear()
            : this.data.forEach((row) => {
                  if (!this.hasBeenUsed(row[this.idFieldName])) {
                      this.selectionModel.select(row);
                  }
              });
    }

    addSelectedItems() {
        this.selectionModel.selected.map((elem) => this.selectRow(elem));
    }

    openDialog(): void {
        this.snackBar.info('Not implemented');
    }

    public toggleCheckbox(row) {
        if (this.hasBeenUsed(row[this.idFieldName])) {
            return;
        }
        this.selectionModel.toggle(row);
    }
}
